<template>
  <div>
    <BtnBaseBlue
      @click="showSpecialInstrux = !showSpecialInstrux"
      outlined
      block
      :disabled="getPlacingOrder"
      :large="_includes(['xs', 'sm'], $mq)"
      >{{ showSpecialInstrux ? 'Hide' : 'Add a' }} Note</BtnBaseBlue
    >
    <transition name="slide-y-transition">
      <v-textarea
        v-if="showSpecialInstrux"
        placeholder="Special Requests/Delivery Instructions"
        rows="2"
        hide-details
        v-model="specialInstrux"
        outlined
        dense
        class="mt-3"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import BtnBaseBlue from '@/components/BtnBaseBlue'

export default {
  name: 'CheckoutSpecialInstructions',
  components: { BtnBaseBlue },
  data() {
    return {
      showSpecialInstrux: false,
    }
  },
  computed: {
    ...mapGetters('cart', ['getPlacingOrder']),
    specialInstrux: {
      get() {
        return _get(this.getTheCart, 'special_instructions', '')
      },
      set(val) {
        this.setSpecialInstructions(val)
      },
    },
  },
  methods: {
    ...mapActions('cart', ['setSpecialInstructions']),
    _includes,
  },
}
</script>
